export const siteUrl = "https://dev-api-sif.vac.az/";
export default siteUrl;
